

<template>

   

<div id="maquette_selection">

<van-row class="height_inher row-btn-choice-maquette" gutter="5" >

  <van-col span="1" class="p-l-10">

</van-col>

<!-- Co A -->
<van-col span="6"  class="height_inher p-l-10">
  <van-image 
  v-if="!StoreCoAChoose" 
    class="opacity_low flip-horizontally img_inher"
    fit="contain"
    position="left"
    v-bind:src="buildCoAImgNoData"
  />

  <van-image 
    v-if="StoreCoAChoose && CodeRefCoA != 'NU' " 
    class="flip-horizontally img_inher img_conector_maquette"
    fit="contain"
    position="left"
    v-bind:src="buildCoAImg"
  />

  <span class="maquette_explique_coA">

    <span  v-if="StoreCoAType"> 
    {{ StoreCoAType }}
    </span>

    <span class="font_12" v-if="StoreCoADiametre"> 
      <hr> 
     <span v-if="StoreCoADiametre != 'none'">{{ $t('Gaine') }} Ø {{ StoreCoADiametre }}</span> 
    </span>

  </span>


</van-col>


<!-- CABLE -->
<van-col span="7" class="height_inher">
  
    <van-image 
    class="opacity_low img_inher"
    v-if="!StoreCableChoose" 
    fit="contain"
    position="left"
    v-bind:src="buildCableImgNoData"
  />

  <van-image 
    v-if="StoreCableChoose" 
    class="img_inher"
    fit="contain"
    position="left"
    v-bind:src="buildCableImg"
  />

  <span class="maquette_explique_cable" style="width: 60%;">

    <span  v-if="StoreCableNombre"> 
    {{ StoreCableNombre }} FO
    </span>

    <span  v-if="StoreCableType"> 
     / {{ StoreCableType }}
    </span>

    <span  v-if="StoreCableEuroclass && StoreCableEuroclass != 'Non applicable'"> 
     / {{ StoreCableEuroclass }}
    </span>

    <span  class="font_12" v-if="StoreCableStructureLibelle"> 
      <hr> 
      <div class="van-text-ellipsis" style="padding-top:4px;">{{ StoreCableStructureLibelle }}</div>
    </span>

  </span>
 
 

</van-col>


<!-- LONGUEUR -->
<van-col span="3" class="height_inher" >


</van-col>



<!-- CO B -->
<van-col span="6" class="height_inher p-r-10" >
  <van-image 
  v-if="!StoreCoBChoose" 
    class="opacity_low img_inher"
    fit="contain"
    position="left"
    v-bind:src="buildCoBImgNoData"
  />

  <van-image 
    v-if="StoreCoBChoose " 
    class="img_inher img_conector_maquette"
    fit="contain"
    position="left"
    v-bind:src="buildCoBImg"
  />

  <span class="maquette_explique_coB">

      <span  v-if="StoreCoBType"> 
      {{ StoreCoBType }}
      </span>

      <span class="font_12" v-if="StoreCoBDiametre"> 
      <hr> {{ $t('Gaine') }} Ø {{ StoreCoBDiametre }}
      
    </span>

    </span>


</van-col>

<van-col span="1" class="p-r-10" >

</van-col>


</van-row>


 </div>



        </template>
        
        
        <script>

        export default {
          components: {
     
          },
          data() {
            return {
                
            }
          },
          created(){
          },
          computed: {

            
                  /**
                   * Connecteur A
                   */

                  /** Co A mage */
                  StoreCoAChoose() {
                    return this.globalFunction.existKeyInArray("diametre",  this.$store.state.storeCoA.coA) 
                        ?  true
                        :  false
                 },
                  StoreCoAType() {
                    return this.globalFunction.existKeyInArray("type",  this.$store.state.storeCoA.coA) 
                        ?  this.$store.state.storeCoA.coA.type.TypeCoA
                        :  false
                 },
                  StoreCoADiametre() {
                    return this.globalFunction.existKeyInArray("diametre",  this.$store.state.storeCoA.coA) 
                        ?  this.$store.state.storeCoA.coA.diametre.typeDiametre
                        :  false
                 },
                 CodeRefCoA(){
                  return this.$store.state.storeCoA.coA.type.codeRefCoA
                 },
                 /**  image coupe Co A */
                 buildCoAImg(){
                  return this.$store.state.storeGlobal.StoreApi + '/images/connecteur_visu/' + this.$store.state.storeCoA.coA.diametre.typeDiametre + '/3quarts/Connecteur_' +  this.$store.state.storeCoA.coA.type.TypeCoA.replace('/', '') + "_" + this.$store.state.storeCable.cable.type.TypeFibre  + ".png"
                 },
                 /**  image coupe Co A */
                 buildCoAImgNoData(){
                  return this.$store.state.storeGlobal.StoreApi + '/images/connecteur_visu/2mm/3quarts/Connecteur_LC_OM3.png';
                 },



            /**
             * Cable
             */

                /** Cable choisie ok */
                StoreCableChoose() {
                    return this.globalFunction.existKeyInArray("reference", this.$store.state.storeCable.cable) 
                        ?  true
                        :  false
                },

                 /**  image coupe de câble */
                 buildCableImg(){
                  // Récupérer le nombre de fibres
    const nombreFibres = this.$store.state.storeCable.cable.nombre.nbFibre;
    
    // Construire le chemin de base
    let basePath = this.$store.state.storeGlobal.StoreApi + '/images/cables_coupe/';
    
    // Si le nombre de fibres est défini, ajouter le sous-dossier correspondant
    if (nombreFibres == '48') {
        basePath += nombreFibres + 'FO/';
    }
    
    // Construire le nom du fichier
    const fileName = this.$store.state.storeCable.cable.structure.codeRefStructureFamille + '_' + 
                    this.$store.state.storeCable.cable.type.TypeFibreCodeRef + ".png";
    
    return basePath + fileName;
                 },
                 /**  image coupe de câble */
                 buildCableImgNoData(){
                  return this.$store.state.storeGlobal.StoreApi + '/images/cables_coupe/LLSOH_M2.png';
                 },

                StoreCableNombre() {
                    return this.globalFunction.existKeyInArray("nombre", this.$store.state.storeCable.cable) 
                        ?  this.$store.state.storeCable.cable.nombre.nbFibre
                        :  false
                },
                StoreCableType() {
                    return this.globalFunction.existKeyInArray("type", this.$store.state.storeCable.cable) 
                        ?  this.$store.state.storeCable.cable.type.TypeFibre
                        :  false
                },
                StoreCableEuroclass() {
                    return this.globalFunction.existKeyInArray("euroclass", this.$store.state.storeCable.cable) 
                        ?  this.$store.state.storeCable.cable.euroclass.nomEuroclass
                        :  false
                },
                StoreCableStructureLibelle() {
                    return this.globalFunction.existKeyInArray("structure", this.$store.state.storeCable.cable) 
                        ?  this.$store.state.storeCable.cable.structure.libelleStructure
                        :  false
                },

                 /**
                  * Connecteur B
                  */
                    /** Co B mage */
                    StoreCoBChoose() {
                      return this.globalFunction.existKeyInArray("diametre",  this.$store.state.storeCoB.coB) 
                        ?  true
                        :  false
                 },
                 /**  image coupe Co B */
                 buildCoBImg(){
                  return this.$store.state.storeGlobal.StoreApi + '/images/connecteur_visu/' + this.$store.state.storeCoB.coB.diametre.typeDiametre + '/3quarts/Connecteur_' +  this.$store.state.storeCoB.coB.type.TypeCoB.replace('/', '') + "_" + this.$store.state.storeCable.cable.type.TypeFibre  + ".png"
                 },
                 /**  image coupe Co B */
                 buildCoBImgNoData(){
                  return this.$store.state.storeGlobal.StoreApi + '/images/connecteur_visu/2mm/3quarts/Connecteur_LC_OM3.png';
                 },
                 StoreCoBType() {
                    return this.globalFunction.existKeyInArray("type",  this.$store.state.storeCoB.coB) 
                        ?  this.$store.state.storeCoB.coB.type.TypeCoB
                        :  false
                 },
                  StoreCoBDiametre() {
                    return this.globalFunction.existKeyInArray("diametre",  this.$store.state.storeCoB.coB) 
                        ?  this.$store.state.storeCoB.coB.diametre.typeDiametre
                        :  false
                 },

          }
        
        
        }
</script>